/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ grade: NonNullable<unknown> }} Rd_GradeInputs */

const en_rd_grade = /** @type {(inputs: Rd_GradeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grade ${i?.grade}`)
};

const id_rd_grade = /** @type {(inputs: Rd_GradeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nilai ${i?.grade}`)
};

/**
* | output |
* | --- |
* | "Grade {grade}" |
*
* @param {Rd_GradeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_grade = /** @type {((inputs: Rd_GradeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_GradeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_grade(inputs)
	return en_rd_grade(inputs)
});